module.exports = __webpack_public_path__ + "img/logo.81aee6e0.png";